import type { SVGProps } from 'react'

export const OciLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 1509 962"
    {...props}
  >
    <path
      fill="#c74634"
      fillRule="evenodd"
      d="M480.98 962c-129.71 3.37-255.22-45.85-348.15-136.44C39.95 734.98-12.45 610.65-12.45 480.8c0-129.79 52.4-254.12 145.28-344.75C225.76 45.46 351.27-3.76 480.98-.39h558.96c125.36 3.27 244.47 55.38 331.98 145.28s136.49 210.42 136.49 335.91c0 125.5-48.98 246.07-136.49 335.92A480.74 480.74 0 0 1 1039.94 962zm546.31-169.4c84.29 2.69 166.09-28.91 226.65-87.61 60.55-58.69 94.78-139.46 94.78-223.84 0-84.39-34.23-165.15-94.78-223.9-60.56-58.7-142.36-90.29-226.65-87.56H493.28c-80.82 2.59-157.44 36.58-213.65 94.69-56.26 58.11-87.71 135.85-87.71 216.77 0 80.91 31.45 158.6 87.71 216.76 56.21 58.11 132.83 92.05 213.65 94.69z"
    ></path>
  </svg>
)
